import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { forumCommentSchema } from './schemas';
import { forumCommentsQueryOptions } from './useForumComments';

type Payload = {
  content: string;
};

export const useUpdateForumComment = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: Payload) => {
      const { data: comment } = await fetchJson(`/forum/comments/${id}`, {
        method: 'PATCH',
        schema: apiResourceSchema(forumCommentSchema),
        body,
      });

      return comment;
    },
    onSuccess: (updatedComment) => {
      queryClient.setQueryData(forumCommentsQueryOptions(updatedComment.postId).queryKey, (comments) =>
        (comments ?? []).map((comment) => (comment.id === updatedComment.id ? updatedComment : comment)),
      );
      queryClient.invalidateQueries(forumCommentsQueryOptions(updatedComment.postId));
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.index.root });
    },
  });
};
